import engineerImg from '../assets/images/engineer.png'
import beFunkyPhotoImg from '../assets/images/BeFunky-photo.jpg'
import logoImg from '../assets/images/logo.png'
import jamesImg from '../assets/images/james_rodriguez.jpg'
import jeremyImg from '../assets/images/jeremy_stein.jpg'
import saraImg from '../assets/images/sara_johnson.jpg'
import thomasImg from '../assets/images/thomas_nonko.jpg'
import workerWhiteImg from '../assets/images/worker-white.png'
import scheduledInitial from '../assets/images/scheduled-initial.png'
import scheduledIntermediate from '../assets/images/scheduled-intermediate.png'
import scheduledFinal from '../assets/images/scheduled-final.png'
import scheduledNot3Initial from '../assets/images/scheduled-not-3days-initial.png'
import scheduledNot3Intermediate from '../assets/images/scheduled-not-3days-intermediate.png'
import scheduledNot3Final from '../assets/images/scheduled-not-3days-final.png'
import unfulfilledInitial from '../assets/images/unfulfilled-initial.png'
import unfulfilledIntermediate from '../assets/images/unfulfilled-intermediate.png'
import unfulfilledFinal from '../assets/images/unfulfilled-final.png'
import completedAddress from '../assets/images/completed-Initial-address.png'
import completedIntermediate from '../assets/images/completed-intermediate.png'
import completedFinal from '../assets/images/completed-Initial-final.png'
import noProfilePicImg from '../assets/images/noprofilepic.jpg'
import visaImg from '../assets/images/credit_cards/visa.png'
import mastercardImg from '../assets/images/credit_cards/mastercard.png'
import amexImg from '../assets/images/credit_cards/american-express.png'
import discoverImg from '../assets/images/credit_cards/discover.png'
import defaultCardImg from '../assets/images/credit_cards/credit-card.png'

export default {
    engineer: engineerImg,
    beFunkyPhoto: beFunkyPhotoImg,
    logo: logoImg,
    james: jamesImg,
    jeremy: jeremyImg,
    sara: saraImg,
    thomas: thomasImg,
    "worker-white": workerWhiteImg,
    "ball": {
        yellow: [scheduledInitial, scheduledIntermediate, scheduledFinal],
        yellow2: [scheduledNot3Initial, scheduledNot3Intermediate, scheduledNot3Final],
        red: [unfulfilledInitial, unfulfilledIntermediate, unfulfilledFinal],
        green: [completedAddress, completedIntermediate, completedFinal],
    },
    noProfilePic: noProfilePicImg,
    "VISA": visaImg,
    "MASTERCARD": mastercardImg,
    'AMEX': amexImg,
    'DISCOVER': discoverImg,
    'DEFAULT': defaultCardImg
}